import { Onderdeel } from '@auth/marktsegmentBeschikbaarheid';
import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Inspectierapporten, {
  onderdeel: Onderdeel.Inspectierapporten,
  isVisible: (settings: EnvironmentSettings) =>
    settings.isActiveAdviseur || settings.isInterneGebruiker,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Inspectierapporten,
    title: 'Inspectierapporten',
    url: '/app/aanvraag/inspectie/',
    iconclass: 'fas fa-clipboard-list-check',
    target: '_top',
  }),
});
